import {
    SET_SUCCESS,
    ADD_ADDON,
    ADD_CART_ITEMS,
    UPDATE_BOOKER,
    LOGOUT_USER,
    LOGIN_AS_CUSTOMER,
    REMOVE_CART_ITEM,
    ACCEPT_TERMS,
    UPDATE_ITEM_GUEST,
    UPDATE_CART_ITEM,
    EMPTY_CART,
    ACTIVITY_BOOKING_NOTE_ACCEPTED,
    SET_CART_ITEM_AGENTNOTE,
    SET_CART_ITEM_CUSTOM_BOOKING,
    SET_CART_ITEM_HAS_CUSTOM_BOOKING,
    UPDATE_CART_DISCOUNT
} from '../actions/actions';

/**
 * Cart
 */
const initialState = {
    /**
     * Data on the booking person
     * @type {{firstname: string, phone: string, email: string, lastname: string}}
     */
    booker: {
        firstname: '',
        lastname: '',
        email: '',
        phone: ''
    },
    /**
     * Each item in the cart, includes the following:
     *      - activity_id
     *      - start_time: '2021-04-23T16:55:00.000Z',
     *      - end_time: '2021-04-23T16:55:00.000Z',
     *      - warning: if there is any
     *      - tickets: list of available tickets added to cart
     *          - id
     *          - name
     *          - booking_fields
     *          - quantity
     *          - retail_price (only if we really need to show some numbers here)
     *          - guests: a list of guest objects, with the booking fields
     *      - addons: list of tickets
     *      - activity: the base activity information, the following should be there
     *          - name
     *      - note
     * */
    cartItems: [],
    /**
     * Booking state?
     */
    success: null,
    /**
     * Terms are accepted on the payment page
     */
    termsAccepted: false,
    /**
     * discount for the whole cart
     */
    discount: {}
};

const initialStateWithCart = (cartItems, booker) => {
    return {
        /**
         * Data on the booking person - preserve if provided
         * @type {{firstname: string, phone: string, email: string, lastname: string}}
         */
        booker: booker || {
            firstname: '',
            lastname: '',
            email: '',
            phone: ''
        },
        /**
         * Keep cartItems
         */
        cartItems,
        /**
         * Booking state?
         */
        success: null,
        /**
         * Terms are accepted on the payment page
         */
        termsAccepted: false,
        // discount
        discount: {}
    };
};

const activities = (state = initialState, action) => {
    if (action.type === EMPTY_CART) {
        const newState = {
            ...state,
            cartItems: [],
            discount: {}
        };

        // Reapply default discount if it exists
        if (window.clientData?.default_discount?.discount) {
            const defaultDiscount = window.clientData.default_discount;
            newState.discount = {
                agencyDiscount: parseFloat(defaultDiscount.discount.agencyDiscount?.amount) || 0,
                vendorDiscount: parseFloat(defaultDiscount.discount.vendorDiscount?.amount) || 0,
                discountPackage: defaultDiscount,
                isDefault: true
            };
        }

        return newState;
    }

    if (action.type === UPDATE_CART_ITEM) {
        // modify an item within an item within an item by id.... madness, pure madness
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) =>
                cartitemIndex === action.cartitemIndex
                    ? {
                          ...action.cartitem
                      }
                    : cartitem
            )
        };
    }

    if (action.type === ACTIVITY_BOOKING_NOTE_ACCEPTED) {
        // modify an item within an item within an item by id.... madness, pure madness
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) =>
                cartitemIndex === action.cartitemIndex
                    ? {
                          ...cartitem,
                          acceptedBookingNotes: true
                      }
                    : cartitem
            )
        };
    }

    if (action.type === SET_CART_ITEM_AGENTNOTE) {
        // modify an item within an item within an item by id.... madness, pure madness
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) =>
                cartitemIndex === action.cartitemIndex
                    ? {
                          ...cartitem,
                          agentnote: action.agentnote
                      }
                    : cartitem
            )
        };
    }

    if (action.type === SET_CART_ITEM_CUSTOM_BOOKING) {
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) =>
                cartitemIndex === action.cartitemIndex
                    ? {
                          ...cartitem,
                          customBooking: action.customBooking
                      }
                    : cartitem
            )
        };
    }

    if (action.type === SET_CART_ITEM_HAS_CUSTOM_BOOKING) {
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) => {
                if (cartitemIndex !== action.cartitemIndex) {
                    return cartitem;
                }

                const cartItem = cartitem;
                if (action.hasCustomBooking === false) {
                    delete cartItem.customBooking;
                }
                return {
                    ...cartItem,
                    hasCustomBooking: action.hasCustomBooking
                };
            })
        };
    }

    if (action.type === ADD_CART_ITEMS) {
        return {
            ...state,
            cartItems: [...state.cartItems, ...action.cartItems]
        };
    }

    if (action.type === REMOVE_CART_ITEM) {
        return {
            ...state,
            cartItems: [
                ...state.cartItems.slice(0, action.cartItemIndex),
                ...state.cartItems.slice(action.cartItemIndex + 1)
            ]
        };
    }

    if (action.type === UPDATE_BOOKER) {
        return {
            ...state,
            booker: action.booker
        };
    }

    if (action.type === UPDATE_CART_DISCOUNT) {
        // reset the whole discount part of the state if the discount is empty
        if (
            typeof action.discount === 'object' &&
            action.discount.agencyDiscount === 0 &&
            action.discount.vendorDiscount === 0
        ) {
            return {
                ...state,
                discount: {}
            };
        }
        return {
            ...state,
            discount: action.discount
        };
    }

    if (action.type === UPDATE_ITEM_GUEST) {
        // modify an item within an item within an item by id.... madness, pure madness
        return {
            ...state,
            cartItems: state.cartItems.map((cartitem, cartitemIndex) =>
                cartitemIndex === action.cartitemIndex
                    ? {
                          ...cartitem,
                          tickets: cartitem.tickets.map(ticketitem =>
                              ticketitem.id === action.ticketId
                                  ? {
                                        ...ticketitem,
                                        guests: ticketitem.guests.map((guest, guestIndex) =>
                                            guestIndex === action.guestIndex
                                                ? { ...guest, ...action.guest }
                                                : guest
                                        )
                                    }
                                  : ticketitem
                          )
                      }
                    : cartitem
            )
        };
    }

    if (action.type === ADD_ADDON) {
        // check if addon is already added with this option
        if (state.cartItems[action.cartItemId].addons.find(addon => addon.id === action.addon.id)) {
            return {
                ...state,
                cartItems: state.cartItems.map((cartItem, id) =>
                    id === action.cartItemId
                        ? {
                              ...cartItem,
                              addons: cartItem.addons
                                  .map(
                                      addon => (addon.id === action.addon.id ? action.addon : addon)
                                      // only keep addons with at least 1 item
                                  )
                                  .filter(e => e.quantity > 0)
                          }
                        : cartItem
                )
            };
        }

        return {
            ...state,
            cartItems: state.cartItems.map((cartItem, id) =>
                id === action.cartItemId
                    ? {
                          ...cartItem,
                          addons: [...cartItem.addons, action.addon]
                      }
                    : cartItem
            )
        };
    }

    if (action.type === SET_SUCCESS) {
        return { ...state, success: action.success };
    }

    if (action.type === ACCEPT_TERMS) {
        return { ...state, termsAccepted: action.accepted };
    }

    // if either the user or the customer of the agent is logged out, remove everything from cart
    if (action.type === LOGOUT_USER) {
        return initialState;
    }

    // since we have an option to keep cartItems we don't need to check action.user
    if (action.type === LOGIN_AS_CUSTOMER) {
        // if keepCart is true we must keep cartItems and booker if they have data
        if (action.keepCart && state.cartItems.length > 0) {
            return initialStateWithCart(state.cartItems, state.booker);
        }
        return initialState;
    }
    return state;
};

export default activities;
